var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5958 1.40417C17.1875 0 14.925 0 10.4167 0H9.58333C5.075 0 2.8125 0 1.40417 1.40417C-0.00416666 2.80833 1.44185e-07 5.075 1.44185e-07 9.58333V10.4167C1.44185e-07 14.925 9.93411e-08 17.1875 1.40417 18.5958C2.80833 20.0042 5.075 20 9.58333 20H10.4167C14.9417 20 17.2042 20 18.6125 18.5958C20.0208 17.1917 20 14.925 20 10.4167V9.58333C20 5.075 20 2.8125 18.5958 1.40417ZM14.35 14.4083C14.1321 13.6277 13.6884 12.9288 13.0746 12.3995C12.4608 11.8702 11.7042 11.5341 10.9 11.4333V14.4083H10.6417C6.08333 14.4083 3.48333 11.2833 3.375 6.075H5.65833C5.73333 9.89167 7.41667 11.4917 8.75 11.8417V6.08333H10.9V9.375C12.2167 9.23333 13.6 7.73333 14.0667 6.08333H16.2167C16.0439 6.94136 15.6956 7.75441 15.1937 8.47143C14.6918 9.18846 14.0471 9.79399 13.3 10.25C14.1329 10.6631 14.8687 11.248 15.4591 11.9662C16.0495 12.6844 16.4809 13.5196 16.725 14.4167L14.35 14.4083Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/VK.53d13b46a6b5164d62d47f01672b085d.svg";
export { ForwardRef as ReactComponent };